// Voice-note recorder: one button, two states — tap to record,
// tap again (or hit the 30s cap) to stop.

export const voiceSupported: boolean = Boolean(
  typeof navigator.mediaDevices?.getUserMedia === "function" && "MediaRecorder" in window
);

export interface RecorderUI {
  button: HTMLButtonElement;
  onDone(blob: Blob): void;
}

let recorder: MediaRecorder | null = null;
let timer: ReturnType<typeof setInterval> | null = null;

/** Update the button's label span, leaving its icon intact. */
const setLabel = (btn: HTMLButtonElement, text: string) => {
  const label = btn.querySelector(".btn-label");
  if (label) label.textContent = text;
  else btn.textContent = text;
};

export async function toggleRecording(ui: RecorderUI): Promise<void> {
  if (recorder?.state === "recording") {
    recorder.stop();
    return;
  }
  const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  const mime = MediaRecorder.isTypeSupported("audio/webm") ? "audio/webm" : "audio/mp4";
  recorder = new MediaRecorder(stream, { mimeType: mime });
  const chunks: Blob[] = [];
  recorder.ondataavailable = (e) => chunks.push(e.data);
  recorder.onstop = () => {
    stream.getTracks().forEach((t) => t.stop());
    if (timer) clearInterval(timer);
    ui.button.classList.remove("recording");
    setLabel(ui.button, "re-record voice note");
    recorder = null;
    ui.onDone(new Blob(chunks, { type: mime }));
  };
  recorder.start();

  const t0 = Date.now();
  ui.button.classList.add("recording");
  timer = setInterval(() => {
    const s = Math.floor((Date.now() - t0) / 1000);
    setLabel(ui.button, `stop · 0:${String(s).padStart(2, "0")} / 0:30`);
    if (s >= 30) recorder?.stop();
  }, 250);
}
